// ======================================================
// 🚀 SCRIPT REGISTRAZIONE CLIENTE + GOOGLE PLACE ELEMENT
// ======================================================
// FORZATO RICARICAMENTO - 20251103-2305

// 🔇 CONFIGURAZIONE DEBUG - Imposta a true per vedere i log di debug
const DEBUG_MODE = false;

// Helper per log condizionali
const debugLog = (...args) => DEBUG_MODE && console.log(...args);
const debugWarn = (...args) => DEBUG_MODE && console.warn(...args);

// Polyfill per AbortSignal.timeout se non supportato dal browser
if (!AbortSignal.timeout) {
  AbortSignal.timeout = function (delay) {
    const controller = new AbortController();
    setTimeout(() => controller.abort(), delay);
    return controller.signal;
  };
}

// Definizione globale dell'oggetto elements
const elements = {
  form: document.querySelector("#register-form"),
  submitBtn: document.querySelector("#register-submit-btn, #register-form button[type='submit'], #register-form input[type='submit']")
};

// ====== GLOBAL SANITIZERS (utili in tutto il file) ======
function sanitizeDigits(value, maxLen) {
  const len = typeof maxLen === 'number' ? maxLen : 32;
  return (value || "").toString().replace(/[^0-9]/g, "").slice(0, len);
}

function sanitizeAlnumUpper(value, maxLen) {
  const len = typeof maxLen === 'number' ? maxLen : 32;
  return (value || "").toString().replace(/[^A-Za-z0-9]/g, "").toUpperCase().slice(0, len);
}

// ====== VALIDAZIONE CAMPI OBBLIGATORI ======
function validateRequiredFields(aziendaCategory) {
  clearFieldErrors();
  const form = document.getElementById('register-form');
  let valid = true;

  // Helper visibilità
  const isVisible = (el) => !!(el && (el.offsetParent !== null));
  const firstEl = (ids) => {
    for (const id of ids) {
      const el = document.getElementById(id);
      if (el) return el;
    }
    return null;
  };

  // 1) Valida tutti i campi con required visibili
  if (form) {
    const requiredInputs = form.querySelectorAll('[required]');
    requiredInputs.forEach((input) => {
      if (!isVisible(input) || input.disabled) return;
      const label = form.querySelector(`label[for='${input.id}']`);
      const fieldName = label?.textContent?.trim() || input.name || 'Campo';
      const value = (input.value || '').trim();
      if (!value) {
        showFieldError(input, `${fieldName} è obbligatorio`);
        if (valid) { try { input.focus(); } catch { } }
        valid = false;
        return;
      }
      // Se presente pattern HTML, valida anche quello
      const pattern = input.getAttribute('pattern');
      if (pattern) {
        const re = new RegExp(`^${pattern}$`);
        if (!re.test(value)) {
          showFieldError(input, `${fieldName} non è nel formato corretto`);
          if (valid) { try { input.focus(); } catch { } }
          valid = false;
        }
      }
    });
  }

  // 1b) Valida esplicitamente i campi aziendali obbligatori se presenti nel DOM (anche senza required)
  const extraRequired = [
    { ids: ['RegisterForm-FirstName'], label: 'Nome' },
    { ids: ['RegisterForm-LastName'], label: 'Cognome' },
    { ids: ['RegisterForm-email'], label: 'Email' },
    { ids: ['RegisterForm-password'], label: 'Password' },
    { ids: ['CompanyName', 'RagioneSocialeFattura'], label: 'Ragione Sociale' },
    { ids: ['IndirizzoFattura', 'CompanyAddress'], label: 'Indirizzo Fatturazione' },
    { ids: ['CAPFattura', 'PostalCodeFattura', 'ZipFattura'], label: 'CAP' },
    { ids: ['CittaFattura', 'CityFattura'], label: 'Città' },
    { ids: ['PaeseFattura', 'CountryFattura'], label: 'Paese' },
    { ids: ['CodiceFiscaleFattura'], label: 'Codice Fiscale' },
    { ids: ['CodiceSDIFattura'], label: 'Codice SDI' },
  ];
  extraRequired.forEach(cfg => {
    const el = firstEl(cfg.ids);
    if (!el || !isVisible(el) || el.disabled) return;
    const v = (el.value || '').trim();
    if (!v) {
      showFieldError(el, `${cfg.label} è obbligatorio`);
      if (valid) { try { el.focus(); } catch { } }
      valid = false;
    }
  });

  // 2) Controlli specifici per categoria e formati opzionali
  const piva = document.getElementById('PartitaIVAFattura');
  if (aziendaCategory === 'azienda-italia' && isVisible(piva)) {
    if (piva && sanitizeDigits(piva.value, 11).length !== 11) {
      showFieldError(piva, 'Partita IVA deve avere 11 cifre');
      try { piva.focus(); } catch { }
      valid = false;
    }
  }

  const sdi = document.getElementById('CodiceSDIFattura');
  if (sdi && isVisible(sdi)) {
    const v = (sdi.value || '').trim();
    if (v && !/^[A-Za-z0-9]{7}$/.test(v)) {
      showFieldError(sdi, 'Codice SDI deve avere 7 caratteri alfanumerici');
      if (valid) { try { sdi.focus(); } catch { } }
      valid = false;
    }
  }

  const cf = document.getElementById('CodiceFiscaleFattura');
  if (cf && isVisible(cf)) {
    const v = (cf.value || '').trim();
    const isValidCF = /^(?:\d{11}|[A-Za-z0-9]{16})$/.test(v);
    if (v && !isValidCF) {
      showFieldError(cf, 'Codice Fiscale: 11 cifre (società) o 16 alfanumerici');
      if (valid) { try { cf.focus(); } catch { } }
      valid = false;
    }
  }

  // Provincia (2 lettere) obbligatoria quando visibile
  const prov = document.getElementById('ProvinciaFattura');
  if (prov && isVisible(prov)) {
    const v = (prov.value || '').trim();
    if (!v) {
      showFieldError(prov, 'Provincia è obbligatoria');
      if (valid) { try { prov.focus(); } catch { } }
      valid = false;
    } else if (!/^[A-Za-z]{2}$/.test(v)) {
      showFieldError(prov, 'Inserire la sigla della provincia (es. RM)');
      if (valid) { try { prov.focus(); } catch { } }
      valid = false;
    }
  }

  const phone = document.getElementById('Telefono');
  if (phone && isVisible(phone)) {
    const v = (phone.value || '').trim();
    if (v && !/^\d{7,15}$/.test(v)) {
      showFieldError(phone, 'Telefono: solo cifre (7-15)');
      if (valid) { try { phone.focus(); } catch { } }
      valid = false;
    }
  }

  return valid;
}

function clearFieldErrors() {
  document.querySelectorAll('.field-error-message').forEach(n => n.remove());
  document.querySelectorAll('.input-error').forEach(n => n.classList.remove('input-error'));
}

function clearFieldErrorFor(inputEl) {
  if (!inputEl) return;
  inputEl.classList.remove('input-error');
  // rimuovi tutti i messaggi di errore immediatamente successivi all'input
  let sib = inputEl.nextSibling;
  while (sib && sib.classList && sib.classList.contains('field-error-message')) {
    const toRemove = sib;
    sib = sib.nextSibling;
    toRemove.remove();
  }
}

function showFieldError(inputEl, message) {
  if (!inputEl) return;
  inputEl.classList.add('input-error');
  // Se esiste già un messaggio subito dopo l'input, aggiornalo invece di crearne uno nuovo
  let next = inputEl.nextSibling;
  if (!(next && next.classList && next.classList.contains('field-error-message'))) {
    const msg = document.createElement('div');
    msg.className = 'field-error-message';
    msg.style.cssText = 'color:#dc2626;font-size:12px;margin-top:4px;';
    msg.textContent = message;
    if (inputEl.parentNode) {
      inputEl.parentNode.insertBefore(msg, inputEl.nextSibling);
    }
  } else {
    next.textContent = message;
  }
  // Evita di registrare più listener di input sullo stesso campo
  if (!inputEl.dataset.errListen) {
    const onInput = () => {
      clearFieldErrorFor(inputEl);
      inputEl.removeEventListener('input', onInput);
      delete inputEl.dataset.errListen;
    };
    inputEl.addEventListener('input', onInput);
    inputEl.dataset.errListen = '1';
  }
}

// NOTA: La funzione createRegistrationPayload è definita più avanti nel file (riga 452)
// Questa definizione semplificata è stata rimossa per evitare conflitti

// Funzioni per la barra di caricamento
function showLoadingBar() {
  const bar = document.createElement("div");
  bar.id = "loading-bar";
  bar.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    height: 4px;
    width: 0%;
    background-color: #0d6efd;
    transition: width 0.3s ease;
    z-index: 9999;
  `;
  document.body.appendChild(bar);
  requestAnimationFrame(() => (bar.style.width = "80%"));
}

function hideLoadingBar(success = true) {
  const bar = document.getElementById("loading-bar");
  if (!bar) return;
  bar.style.width = "100%";
  bar.style.backgroundColor = success ? "#22c55e" : "#dc2626";
  setTimeout(() => bar.remove(), 500);
}

document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('register-form');
  if (!form) {
    console.error("❌ Form non trovato!");
    return;
  }

  debugLog("✅ Script caricato correttamente, form:", form);

  // Cache degli elementi DOM - estende l'oggetto elements globale
  elements.emailInput = form.querySelector('input[name="customer[email]"]');
  elements.passwordInput = form.querySelector('input[name="customer[password]"]');
  elements.categoryButtons = document.querySelectorAll('.category-btn');
  elements.switchToggle = document.getElementById('registration-type-switch');
  elements.aziendaFields = document.getElementById('azienda-fields');
  elements.companyName = document.getElementById('CompanyName');
  elements.companyAddress = document.getElementById('CompanyAddress');
  elements.vatNumber = document.getElementById('VatNumber');
  // Se non trovato con ID VatNumber, proviamo con PartitaIVAFattura che è l'ID usato nel HTML
  if (!elements.vatNumber) {
    elements.vatNumber = document.getElementById('PartitaIVAFattura');
  }

  elements.noSdiCheckbox = document.getElementById('NoCodiceSDI');
  elements.sdiInput = document.getElementById('CodiceSDIFattura');

  // ======================================================
  // 🔘 Gestione Checkbox "Non possiedo codice SDI"
  // ======================================================
  if (elements.noSdiCheckbox && elements.sdiInput) {
    // Stato iniziale: disabilita checkbox se non c'è P.IVA (eccetto Professionista)
    const updateCheckboxState = () => {
      // Recupera la categoria corrente
      // Nota: elements.categoryButtons potrebbe non essere aggiornato se definito prima, usiamo querySelector per sicurezza
      const activeBtn = document.querySelector('.category-btn.is-active');
      const category = activeBtn ? activeBtn.getAttribute('data-category') : '';
      const isProfessionista = category === 'professionista';
      const hasVat = elements.vatNumber && elements.vatNumber.value.trim().length > 0;

      if (isProfessionista || hasVat) {
        elements.noSdiCheckbox.disabled = false;
        elements.noSdiCheckbox.parentElement.style.opacity = '1';
        elements.noSdiCheckbox.parentElement.style.cursor = 'default';
      } else {
        elements.noSdiCheckbox.disabled = true;

        // Se disabilitiamo, dobbiamo deselezionare?
        // Solo se NON siamo professionista e NON c'è P.IVA
        if (elements.noSdiCheckbox.checked) {
          elements.noSdiCheckbox.checked = false;
          // Reset del campo SDI se viene deselezionato automaticamente
          elements.sdiInput.value = '';
          elements.sdiInput.removeAttribute('readonly');
          elements.sdiInput.classList.remove('is-locked');
        }

        elements.noSdiCheckbox.parentElement.style.opacity = '0.5';
        elements.noSdiCheckbox.parentElement.style.cursor = 'not-allowed';
      }
    };

    // Esegui allo start
    updateCheckboxState();

    // Listener sulla Partita IVA
    if (elements.vatNumber) {
      elements.vatNumber.addEventListener('input', updateCheckboxState);
    }

    // Listener sul cambio categoria
    if (elements.categoryButtons) {
      elements.categoryButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          // Timeout per permettere all'altro listener di aggiornare la classe is-active
          setTimeout(updateCheckboxState, 100);
        });
      });
    }

    elements.noSdiCheckbox.addEventListener('change', function () {
      if (this.checked) {
        elements.sdiInput.value = '0000000';
        elements.sdiInput.setAttribute('readonly', 'readonly');
        elements.sdiInput.classList.add('is-locked'); // Opzionale per stile
        // Rimuove eventuali errori di validazione
        clearFieldErrorFor(elements.sdiInput);
      } else {
        elements.sdiInput.value = '';
        elements.sdiInput.removeAttribute('readonly');
        elements.sdiInput.classList.remove('is-locked');
      }
    });
  }

  // Stato del form
  const state = {
    emailVerified: false,
    isAzienda: false
  };

  // Disabilita campo password e pulsanti categoria all'inizio
  if (elements.passwordInput) {
    elements.passwordInput.disabled = true;
    elements.passwordInput.placeholder = "Inserisci email prima...";
  }

  // Disabilita i pulsanti delle categorie aziendali
  if (elements.categoryButtons) {
    elements.categoryButtons.forEach(btn => {
      btn.disabled = true;
      btn.style.opacity = '0.5';
      btn.style.cursor = 'not-allowed';
    });
  }

  elements.emailInput.addEventListener('blur', async () => {
    const email = elements.emailInput.value.trim();
    if (!email) return;

    // Rimuovi messaggi di errore precedenti
    removeEmailMessages();

    // Validazione base dell'email
    if (!isValidEmail(email)) {
      showEmailInvalidWarning();
      return;
    }

    // Mostra indicatore di ricerca
    const searchIndicator = createSearchIndicator();
    if (elements.emailInput && elements.emailInput.parentNode) {
      elements.emailInput.parentNode.appendChild(searchIndicator);
    } else {
      console.error("❌ Errore: input email o suo nodo padre non trovato");
      return;
    }

    try {
      const response = await fetch("https://api.licenseglobal.it/api/check-customer-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
        signal: AbortSignal.timeout(10000)
      });

      // Controlla se la risposta è ok prima di fare il parsing
      if (!response.ok) {
        throw new Error(`Errore HTTP: ${response.status} ${response.statusText}`);
      }

      const data = await response.json();
      searchIndicator.remove();

      if (data.exists) {
        handleEmailExists(email);
      } else {
        handleEmailNew();
      }
    } catch (err) {
      console.error("❌ Errore durante la verifica email:", err);
      searchIndicator.remove();

      // Gestione specifica per errori di rete
      if (err.name === 'AbortError') {
        handleEmailError(new Error("Server lento. Riprova più tardi."));
      } else if (err.name === 'TypeError' && err.message.includes('Failed to fetch')) {
        handleEmailError(new Error("Impossibile connettersi al server. Controlla la tua connessione."));
      } else {
        handleEmailError(err);
      }
    }
  });

  // Funzioni helper per la gestione dell'email
  function removeEmailMessages() {
    document.querySelector('.email-invalid-warning')?.remove();
    document.querySelector('.email-exists-warning')?.remove();
  }

  function createSearchIndicator() {
    const searchIndicator = document.createElement('div');
    searchIndicator.className = 'email-search-indicator';
    searchIndicator.style.cssText = `
      font-size: 0.8rem;
      color: #d84c00;
      margin-top: 4px;
      font-style: italic;
      display: flex;
      align-items: center;
    `;
    searchIndicator.innerHTML = `
      <span style="display: inline-block; width: 12px; height: 12px; border: 2px solid #d84c00; border-radius: 50%; border-top-color: transparent; margin-right: 6px; animation: spin 1s linear infinite;"></span>
      Verifica email in corso...
    `;
    return searchIndicator;
  }

  function handleEmailExists(email) {
    showEmailExistsWarning(email);

    // Verifica che il pulsante di submit e il suo parentNode esistano
    if (!elements.submitBtn || !elements.submitBtn.parentNode) {
      console.error("❌ Errore: pulsante di submit o suo nodo padre non trovato");
      return;
    }

    const loginBtn = document.createElement('button');
    loginBtn.type = 'button';
    loginBtn.className = elements.submitBtn.className;
    loginBtn.textContent = "Accedi al tuo account";
    loginBtn.setAttribute('data-original-text', elements.submitBtn.getAttribute('data-original-text'));

    loginBtn.addEventListener('click', function (e) {
      e.preventDefault();
      window.location.href = 'https://licenseglobal.it/account/login';
    });

    elements.submitBtn.parentNode.replaceChild(loginBtn, elements.submitBtn);

    // Disabilita campi
    if (elements.passwordInput) {
      elements.passwordInput.disabled = true;
      elements.passwordInput.placeholder = "Email già registrata";
    }

    if (elements.categoryButtons) {
      elements.categoryButtons.forEach(btn => {
        btn.disabled = true;
        btn.style.opacity = '0.5';
        btn.style.cursor = 'not-allowed';
      });
    }

    state.emailVerified = true;
  }

  function handleEmailNew() {
    // Verifica che gli elementi esistano prima di manipolarli
    if (elements.submitBtn) {
      elements.submitBtn.disabled = false;
      elements.submitBtn.textContent = elements.submitBtn.getAttribute('data-original-text') || "CREARE UN PROFILO";
    }

    if (elements.passwordInput) {
      elements.passwordInput.disabled = false;
      elements.passwordInput.placeholder = "******";
    }

    if (elements.categoryButtons) {
      elements.categoryButtons.forEach(btn => {
        btn.disabled = false;
        btn.style.opacity = '1';
        btn.style.cursor = 'pointer';
      });
    }

    state.emailVerified = true;
  }

  function handleEmailError(err) {
    let errorMessage = "Errore durante la verifica dell'email. Riprova.";
    if (err.name === 'AbortError') {
      errorMessage = "Server lento. Riprova più tardi.";
    }

    // Verifica che l'input email e il suo parentNode esistano
    if (!elements.emailInput || !elements.emailInput.parentNode) {
      console.error("❌ Errore: input email o suo nodo padre non trovato");
      return;
    }

    const errorDiv = document.createElement('div');
    errorDiv.className = 'email-verification-message';
    errorDiv.style.cssText = `
      margin-top: 8px;
      padding: 8px 10px;
      background: #fee2e2;
      border: 1px solid #fecaca;
      color: #991b1b;
      border-radius: 4px;
      font-size: 0.85rem;
    `;
    errorDiv.textContent = errorMessage;

    elements.emailInput.parentNode.appendChild(errorDiv);
    setTimeout(() => errorDiv.remove(), 5000);
  }

  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  function showEmailInvalidWarning() {
    removeEmailMessages();

    // Verifica che l'input email e il suo parentNode esistano
    if (!elements.emailInput || !elements.emailInput.parentNode) {
      console.error("❌ Errore: input email o suo nodo padre non trovato");
      return;
    }

    const warning = document.createElement('div');
    warning.className = 'email-invalid-warning';
    warning.style.cssText = `
      margin-top: 8px;
      padding: 8px 10px;
      background: #fee2e2;
      border: 1px solid #fecaca;
      color: #991b1b;
      border-radius: 4px;
      font-size: 0.85rem;
      line-height: 1.3;
    `;

    warning.innerHTML = `
      ❌ Inserisci un indirizzo email valido (es. nome@dominio.com)
    `;

    elements.emailInput.parentNode.appendChild(warning);
  }

  function showEmailExistsWarning(email) {
    if (document.querySelector('.email-exists-warning')) return;

    // Verifica che l'input email e il suo parentNode esistano
    if (!elements.emailInput || !elements.emailInput.parentNode) {
      console.error("❌ Errore: input email o suo nodo padre non trovato");
      return;
    }

    const warning = document.createElement('div');
    warning.className = 'email-exists-warning';
    warning.style.cssText = `
      margin-top: 8px;
      padding: 8px 10px;
      background: #fff8e1;
      border: 1px solid #ffecb3;
      color: #a16207;
      border-radius: 4px;
      font-size: 0.85rem;
      line-height: 1.3;
    `;

    warning.innerHTML = `
      ⚠️ Email già registrata. <a href="/account/login" style="color:#b45309;text-decoration:underline;font-weight:600;">Accedi</a> o <a href="/account/login#recover" style="color:#b45309;text-decoration:underline;font-weight:600;">resetta password</a>
    `;

    elements.emailInput.parentNode.appendChild(warning);
  }

  // Salva il testo originale del pulsante
  if (elements.submitBtn) {
    elements.submitBtn.setAttribute('data-original-text', elements.submitBtn.textContent);
  }

  // ======================================================
  // 👔 Mostra/Nascondi campi aziendali + classe body
  // ======================================================
  function toggleAziendaFields() {
    if (!elements.switchToggle) {
      console.error("❌ Errore: switch toggle non trovato");
      return;
    }

    state.isAzienda = elements.switchToggle.checked;
    const email = elements.emailInput ? elements.emailInput.value.trim() : '';

    if (state.isAzienda && elements.aziendaFields) {
      elements.aziendaFields.style.display = 'block';
      setTimeout(() => elements.aziendaFields.classList.add('form-slide-in'), 50);
    } else if (elements.aziendaFields) {
      elements.aziendaFields.classList.add('form-slide-out');
      setTimeout(() => {
        elements.aziendaFields.style.display = 'none';
        elements.aziendaFields.classList.remove('form-slide-in', 'form-slide-out');
      }, 300);
    }

    document.body.classList.toggle('azienda-mode', state.isAzienda);

    // Controlla se l'email è stata verificata prima di abilitare i pulsanti categoria
    if ((!email || !state.emailVerified) && elements.categoryButtons) {
      elements.categoryButtons.forEach(btn => {
        btn.disabled = true;
        btn.style.opacity = '0.5';
        btn.style.cursor = 'not-allowed';
      });
    }
  }

  if (elements.switchToggle) {
    elements.switchToggle.addEventListener('change', toggleAziendaFields);
    toggleAziendaFields();
  }
});


// ======================================================
// 🧩 Funzione per normalizzare la provincia
// ======================================================
function normalizeProvince(provinciaRaw) {
  if (!provinciaRaw) return "";

  // Rimuovi spazi e converti in maiuscolo
  let cleaned = provinciaRaw.toString().trim().toUpperCase();

  // Se è già una sigla di 2 caratteri, restituiscila direttamente
  if (cleaned.length === 2 && /^[A-Z]{2}$/.test(cleaned)) {
    return cleaned;
  }

  // Mappa delle province italiane
  const provinceMap = {
    "AGRIGENTO": "AG", "ALESSANDRIA": "AL", "ANCONA": "AN", "AOSTA": "AO", "AREZZO": "AR",
    "ASCOLI PICENO": "AP", "ASTI": "AT", "AVELLINO": "AV", "BARI": "BA", "BARLETTA-ANDRIA-TRANI": "BT",
    "BELLUNO": "BL", "BENEVENTO": "BN", "BERGAMO": "BG", "BIELLA": "BI", "BOLOGNA": "BO",
    "BOLZANO": "BZ", "BRESCIA": "BS", "BRINDISI": "BR", "CAGLIARI": "CA", "CALTANISSETTA": "CL",
    "CAMPOBASSO": "CB", "CARBONIA-IGLESIAS": "CI", "CASERTA": "CE", "CATANIA": "CT", "CATANZARO": "CZ",
    "CHIETI": "CH", "COMO": "CO", "COSENZA": "CS", "CREMONA": "CR", "CROTONE": "KR",
    "CUNEO": "CN", "ENNA": "EN", "FERMO": "FM", "FERRARA": "FE", "FIRENZE": "FI",
    "FOGGIA": "FG", "FORLÌ-CESENA": "FC", "FROSINONE": "FR", "GENOVA": "GE", "GORIZIA": "GO",
    "GROSSETO": "GR", "IMPERIA": "IM", "ISERNIA": "IS", "LA SPEZIA": "SP", "L'AQUILA": "AQ",
    "LATINA": "LT", "LECCE": "LE", "LECCO": "LC", "LIVORNO": "LI", "LODI": "LO",
    "LUCCA": "LU", "MACERATA": "MC", "MANTOVA": "MN", "MASSA-CARRARA": "MS", "MATERA": "MT",
    "MEDIO CAMPIDANO": "VS", "MESSINA": "ME", "MILANO": "MI", "MODENA": "MO", "MONZA E DELLA BRIANZA": "MB",
    "NAPOLI": "NA", "NOVARA": "NO", "NUORO": "NU", "OLBIA-TEMPIO": "OT", "ORISTANO": "OR",
    "PADOVA": "PD", "PALERMO": "PA", "PARMA": "PR", "PAVIA": "PV", "PERUGIA": "PG",
    "PESARO E URBINO": "PU", "PESCARA": "PE", "PIACENZA": "PC", "PISA": "PI", "PISTOIA": "PT",
    "PORDENONE": "PN", "POTENZA": "PZ", "PRATO": "PO", "RAGUSA": "RG", "RAVENNA": "RA",
    "REGGIO CALABRIA": "RC", "REGGIO EMILIA": "RE", "RIETI": "RI", "RIMINI": "RN", "ROMA": "RM",
    "ROVIGO": "RO", "SALENNO": "SA", "SASSARI": "SS", "SAVONA": "SV", "SIENA": "SI",
    "SIRACUSA": "SR", "SONDRIO": "SO", "TARANTO": "TA", "TERAMO": "TE", "TERNI": "TR",
    "TORINO": "TO", "TRAPANI": "TP", "TRENTO": "TN", "TREVISO": "TV", "TRIESTE": "TS",
    "UDINE": "UD", "VARESE": "VA", "VENEZIA": "VE", "VERBANIA": "VB", "VERCELLI": "VC",
    "VERONA": "VR", "VIBO VALENTIA": "VV", "VICENZA": "VI", "VITERBO": "VT"
  };

  // Rimuovi prefissi comuni
  cleaned = cleaned
    .replace(/^PROVINCIA DI\s*/i, "")
    .replace(/^CITTÀ METROPOLITANA DI\s*/i, "")
    .replace(/^METROPOLITAN CITY OF\s*/i, "")
    .replace(/^PROVINCE OF\s*/i, "")
    .replace(/^REGIONE\s*/i, "")
    .trim();

  // Cerca nella mappa
  if (provinceMap[cleaned]) {
    return provinceMap[cleaned];
  }

  // Cerca corrispondenza parziale nella mappa
  for (const [fullName, abbreviation] of Object.entries(provinceMap)) {
    if (fullName.includes(cleaned) || cleaned.includes(fullName)) {
      return abbreviation;
    }
  }

  // Fallback: prime due lettere maiuscole
  return cleaned.substring(0, 2).toUpperCase();
}

// ======================================================
// 🧩 Funzione helper per creare il payload completo
// ======================================================
function createRegistrationPayload(aziendaCategory) {
  // Sanitize helper per telefono (solo cifre, max 15)
  function sanitizePhone(value) {
    return (value || "").toString().replace(/[^0-9]/g, "").slice(0, 15);
  }
  function sanitizeDigits(value, maxLen) {
    const len = typeof maxLen === "number" ? maxLen : 32;
    return (value || "").toString().replace(/[^0-9]/g, "").slice(0, len);
  }
  function sanitizeAlnumUpper(value, maxLen) {
    const len = typeof maxLen === "number" ? maxLen : 32;
    return (value || "").toString().replace(/[^A-Za-z0-9]/g, "").toUpperCase().slice(0, len);
  }
  // Recupera i dati della fatturazione automatica
  const fatturaAutomaticaToggle = document.getElementById("fattura-automatica-toggle");
  const clienteUEToggle = document.getElementById("ClienteUEToggle");

  // Recupera tutti i valori direttamente dal DOM
  const email = document.querySelector('input[name="customer[email]"]')?.value.trim() || "";
  const firstName = document.querySelector('input[name="customer[first_name]"]')?.value.trim() || "";
  const lastName = document.querySelector('input[name="customer[last_name]"]')?.value.trim() || "";
  const password = document.querySelector('input[name="customer[password]"]')?.value.trim() || "";

  // Recupera i valori dei campi aziendali direttamente dal DOM
  const companyName = document.getElementById("CompanyName")?.value.trim() || "";
  const companyAddress = document.getElementById("CompanyAddress")?.value.trim() || "";
  const vatNumber = sanitizeDigits(document.getElementById("VatNumber")?.value.trim() || "", 11);

  // Determina l'indirizzo in base al tipo di registrazione
  let indirizzoValue = "";
  if (aziendaCategory) {
    // Per aziende, usa SEMPRE l'indirizzo di fatturazione (campo obbligatorio)
    // Se IndirizzoFattura è vuoto, usa CompanyAddress come fallback solo se disponibile
    const indirizzoFattura = document.getElementById("IndirizzoFattura")?.value.trim() || "";
    indirizzoValue = indirizzoFattura || companyAddress || "";

    // Log per debug se l'indirizzo è vuoto
    if (!indirizzoValue) {
      debugWarn("⚠️ Attenzione: Indirizzo fatturazione vuoto per azienda");
    }
  } else {
    // Per privati, usa l'indirizzo standard
    indirizzoValue = document.getElementById("Address")?.value.trim() || companyAddress || "";
  }

  // 🌍 Funzione per convertire country_code a nome paese in inglese (se il paese è vuoto)
  function getCountryNameFromCode(countryCode) {
    if (!countryCode || countryCode === "IT") return "Italy";

    try {
      // ✅ Usa Intl.DisplayNames se disponibile (supporta tutti i paesi)
      if (typeof Intl !== "undefined" && Intl.DisplayNames) {
        const regionNames = new Intl.DisplayNames(["en"], { type: "region" });
        const countryName = regionNames.of(countryCode);
        if (countryName) return countryName;
      }
    } catch (err) {
      debugWarn(`⚠️ Intl.DisplayNames non disponibile per ${countryCode}`);
    }

    // ⚠️ Fallback: mappa completa (solo se Intl.DisplayNames fallisce)
    const countryMap = {
      "US": "United States", "GB": "United Kingdom", "FR": "France", "DE": "Germany",
      "ES": "Spain", "PT": "Portugal", "NL": "Netherlands", "BE": "Belgium",
      "AT": "Austria", "CH": "Switzerland", "PL": "Poland", "CZ": "Czechia",
      "SE": "Sweden", "NO": "Norway", "DK": "Denmark", "FI": "Finland",
      "IE": "Ireland", "GR": "Greece", "RO": "Romania", "HU": "Hungary",
      "BG": "Bulgaria", "HR": "Croatia", "SK": "Slovakia", "SI": "Slovenia",
      "LT": "Lithuania", "LV": "Latvia", "EE": "Estonia", "CY": "Cyprus",
      "MT": "Malta", "LU": "Luxembourg", "CA": "Canada", "AU": "Australia",
      "NZ": "New Zealand", "JP": "Japan", "CN": "China", "KR": "Korea, Republic of",
      "IN": "India", "BR": "Brazil", "MX": "Mexico", "AR": "Argentina",
      "CL": "Chile", "CO": "Colombia", "PE": "Peru", "ZA": "South Africa",
      "EG": "Egypt", "AE": "United Arab Emirates", "SA": "Saudi Arabia",
      "IL": "Israel", "TR": "Turkey", "RU": "Russian Federation", "UA": "Ukraine"
    };
    return countryMap[countryCode] || "";
  }

  // Determina il paese in base al tipo di registrazione
  let countryValue = "";
  let countryCodeValue = "";

  if (aziendaCategory) {
    // Distingui tra aziende italiane e aziende estere
    const isAziendaEstera = aziendaCategory === "azienda-estera";

    if (isAziendaEstera) {
      // Per aziende ESTERE: usa il paese rilevato da Google Places
      const paeseFatturaRaw = document.getElementById("PaeseFattura")?.value?.trim() || "";
      // Il paese viene già popolato in inglese da Google Places (es. "United States")

      // Recupera il country code dal campo nascosto (popolato da Google Places)
      countryCodeValue = document.getElementById("CountryCodeFattura")?.value?.trim().toUpperCase() ||
        document.getElementById("PaeseFattura")?.getAttribute("data-country-code")?.toUpperCase() ||
        document.getElementById("CountryCode")?.value?.trim().toUpperCase() || "IT";

      // Determina il paese: usa quello dal campo se presente, altrimenti converti dal country_code
      // ⚠️ NON usare "Italy" come fallback se country_code è diverso da "IT"
      countryValue = paeseFatturaRaw;
      if (!countryValue && countryCodeValue) {
        if (countryCodeValue === "IT") {
          countryValue = "Italy";
        } else {
          // Se il paese è vuoto ma c'è un country_code diverso da "IT", convertilo
          countryValue = getCountryNameFromCode(countryCodeValue);
          if (!countryValue) {
            debugWarn(`⚠️ Paese non trovato per country_code: ${countryCodeValue}`);
            // Se non trovato, usa il country_code come fallback (non "Italy")
            countryValue = countryCodeValue;
          }
        }
      } else if (!countryValue) {
        // Solo se non c'è né paese né country_code, usa "Italy" come default
        countryValue = "Italy";
        countryCodeValue = "IT";
      }
    } else {
      // Per aziende ITALIANE (azienda-italia, professionista): forza sempre "Italy"
      countryValue = "Italy";
      countryCodeValue = "IT";
    }
  } else {
    // Per privati, usa il paese standard
    countryValue = document.getElementById("Country")?.value?.trim() || "Italy";
    countryCodeValue = document.getElementById("CountryCode")?.value?.trim().toUpperCase() || "IT";
  }

  // Recupera i valori dei campi extra direttamente dal DOM
  const cap = (aziendaCategory ? document.getElementById("CAPFattura")?.value.trim() : document.getElementById("PostalCode")?.value.trim()) || "";
  const citta = (aziendaCategory ? document.getElementById("CittaFattura")?.value.trim() : document.getElementById("City")?.value.trim()) || "";
  const provincia = normalizeProvince(
    aziendaCategory
      ? document.getElementById("ProvinciaFattura")?.value.trim()
      : document.getElementById("Province")?.value
  ) || "";
  const telefono = sanitizePhone(document.getElementById("Phone")?.value.trim() || "");
  const codiceFiscale = sanitizeAlnumUpper(document.getElementById("CodiceFiscale")?.value.trim() || "", 16);
  const codiceSdi = sanitizeAlnumUpper(document.getElementById("CodiceSDI")?.value.trim() || "", 7);

  const payload = {
    email,
    first_name: firstName,
    last_name: lastName,
    password,
    phone: telefono, // Aggiunto campo phone principale
    address1: indirizzoValue, // Aggiunto campo address1 per l'indirizzo principale
    city: citta, // Aggiunto campo city principale
    zip: cap, // Aggiunto campo zip principale
    province: provincia, // Aggiunto campo province principale
    country: countryValue, // Aggiunto campo country principale
    country_code: countryCodeValue, // Aggiunto campo country_code principale
    extra_fields: {
      tipo_registrazione: aziendaCategory || "privato",
      azienda: companyName,
      indirizzo_azienda: companyAddress,
      partita_iva: vatNumber,
      azienda_category: aziendaCategory,
      cap,
      citta,
      provincia,
      indirizzo: indirizzoValue, // Usiamo lo stesso valore per consistenza
      telefono,
      country: countryValue, // Usiamo lo stesso valore per consistenza
      country_code: countryCodeValue, // Usiamo lo stesso valore per consistenza
      codice_fiscale: document.getElementById("RegisterForm-codice_fiscale")?.value.trim() || "",
      codice_sdi: codiceSdi
    },
    // Metafields per la fatturazione automatica
    metafields: {}
  };

  // ✅ IMPORTANTE: Leggi sempre i metafields dal toggle, indipendentemente dallo stato
  // Questo permette di salvare sempre il valore corretto del toggle
  const allMetafields = {
    "fa_fields.fattura_automatica": fatturaAutomaticaToggle ? fatturaAutomaticaToggle.checked : false,
    "fa_fields.cliente_ue": clienteUEToggle ? clienteUEToggle.checked : false,
    "fa_fields.ragione_sociale": document.getElementById("RagioneSocialeFattura")?.value.trim() || "",
    "fa_fields.partita_iva": sanitizeDigits(document.getElementById("PartitaIVAFattura")?.value.trim() || "", 11),
    "fa_fields.codice_fiscale": sanitizeAlnumUpper(document.getElementById("CodiceFiscaleFattura")?.value.trim() || "", 16),
    "fa_fields.codice_sdi": sanitizeAlnumUpper(document.getElementById("CodiceSDIFattura")?.value.trim() || "", 7)
  };

  // 🔒 FILTRA i metafields vuoti per evitare errori 422 "can't be blank" da Shopify
  // Shopify rifiuta metafields con stringa vuota, quindi inviamo solo quelli con valore
  payload.metafields = Object.fromEntries(
    Object.entries(allMetafields).filter(([key, value]) => {
      // Mantieni i boolean (anche se false) e le stringhe non vuote
      return typeof value === 'boolean' || (typeof value === 'string' && value !== '');
    })
  );

  debugLog("✅ Metafields generati (filtrati):", payload.metafields);

  // 🔒 SICUREZZA: Non loggare il payload completo perché contiene la password
  const { password: pwd, ...payloadWithoutPassword } = payload;
  debugLog("✅ Payload verificato e completo (senza password):", payloadWithoutPassword);
  return payload;
}


// ======================================================
// 📱 FUNZIONE PER MOSTRARE MESSAGGI DI SINCRONIZZAZIONE
// ======================================================
function showSyncMessage(message, type) {
  // Rimuovi messaggi precedenti
  const existingMessage = document.querySelector(".sync-message");
  if (existingMessage) existingMessage.remove();

  // Crea il nuovo messaggio
  const syncMessage = document.createElement("div");
  syncMessage.className = "sync-message";
  let bgColor, borderColor, textColor;

  switch (type) {
    case "loading":
      bgColor = "#f0f9ff";
      borderColor = "#bae6fd";
      textColor = "#0369a1";
      break;
    case "success":
      bgColor = "#f0fdf4";
      borderColor = "#bbf7d0";
      textColor = "#166534";
      break;
    case "error":
      bgColor = "#fef2f2";
      borderColor = "#fecaca";
      textColor = "#991b1b";
      break;
  }

  syncMessage.style.cssText = `
    padding: 12px 16px;
    margin-top: 10px;
    background: ${bgColor};
    border: 1px solid ${borderColor};
    color: ${textColor};
    border-radius: 6px;
    font-size: 0.9rem;
    font-weight: 500;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: fadeIn 0.3s ease-out;
  `;

  syncMessage.textContent = message;

  // Inserisci sotto al pulsante di submit
  if (elements.submitBtn && elements.submitBtn.parentNode) {
    elements.submitBtn.parentNode.insertBefore(syncMessage, elements.submitBtn.nextSibling);
  }

  // Auto-nascondi dopo 6 secondi se non è "loading"
  if (type === "success" || type === "error") {
    setTimeout(() => {
      if (syncMessage && syncMessage.parentNode) {
        syncMessage.style.animation = "fadeOut 0.3s ease-out forwards";
        setTimeout(() => syncMessage.remove(), 300);
      }
    }, 6000);
  }
}

// ======================================================
// ✅ FUNZIONE PER MOSTRARE POPUP DI REGISTRAZIONE COMPLETATA
// ======================================================
function showRegistrationSuccessModal() {
  // Rimuovi modali esistenti
  const existingModal = document.querySelector(".registration-success-modal");
  if (existingModal) existingModal.remove();

  // Crea overlay
  const overlay = document.createElement("div");
  overlay.className = "registration-success-modal-overlay";
  overlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: fadeIn 0.3s ease-out;
  `;

  // Crea modale
  const modal = document.createElement("div");
  modal.className = "registration-success-modal";
  modal.style.cssText = `
    background: white;
    border-radius: 16px;
    padding: 2rem;
    max-width: 500px;
    width: 90%;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    text-align: center;
    animation: slideUp 0.4s ease-out;
    position: relative;
  `;

  // Icona di successo
  const icon = document.createElement("div");
  icon.innerHTML = `
    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin: 0 auto;">
      <circle cx="12" cy="12" r="10" fill="#22c55e" opacity="0.1"/>
      <path d="M9 12l2 2 4-4" stroke="#22c55e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <circle cx="12" cy="12" r="10" stroke="#22c55e" stroke-width="2"/>
    </svg>
  `;
  icon.style.cssText = `
    margin-bottom: 1.5rem;
    display: flex;
    justify-content: center;
  `;

  // Titolo
  const title = document.createElement("h2");
  title.textContent = "Registrazione completata!";
  title.style.cssText = `
    font-size: 1.5rem;
    font-weight: 700;
    color: #1f2937;
    margin: 0 0 1rem 0;
  `;

  // Messaggio
  const message = document.createElement("p");
  message.textContent = "Il tuo account è stato creato con successo. Accedi ora!";
  message.style.cssText = `
    font-size: 1rem;
    color: #6b7280;
    margin: 0 0 2rem 0;
    line-height: 1.6;
  `;

  // Pulsante per andare al login
  const loginButton = document.createElement("button");
  loginButton.textContent = "Vai al Login";
  loginButton.className = "registration-success-button";
  loginButton.style.cssText = `
    background: #16a34a;
    color: white;
    border: none;
    padding: 0.75rem 2rem;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s;
    width: 100%;
    margin-bottom: 0.75rem;
  `;

  loginButton.addEventListener("mouseenter", () => {
    loginButton.style.background = "#15803d";
  });
  loginButton.addEventListener("mouseleave", () => {
    loginButton.style.background = "#16a34a";
  });

  loginButton.addEventListener("click", () => {
    window.location.href = "/account/login";
  });

  // Pulsante per chiudere
  const closeButton = document.createElement("button");
  closeButton.textContent = "Chiudi";
  closeButton.style.cssText = `
    background: transparent;
    color: #6b7280;
    border: 1px solid #e5e7eb;
    padding: 0.75rem 2rem;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    width: 100%;
  `;

  closeButton.addEventListener("mouseenter", () => {
    closeButton.style.background = "#f9fafb";
    closeButton.style.borderColor = "#d1d5db";
  });
  closeButton.addEventListener("mouseleave", () => {
    closeButton.style.background = "transparent";
    closeButton.style.borderColor = "#e5e7eb";
  });

  closeButton.addEventListener("click", () => {
    overlay.remove();
  });

  // Chiudi cliccando sull'overlay
  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) {
      overlay.remove();
    }
  });

  // Assemblea modale
  modal.appendChild(icon);
  modal.appendChild(title);
  modal.appendChild(message);
  modal.appendChild(loginButton);
  modal.appendChild(closeButton);
  overlay.appendChild(modal);

  // Aggiungi al body
  document.body.appendChild(overlay);

  // Aggiungi animazioni CSS se non esistono
  if (!document.querySelector("#registration-success-animations")) {
    const style = document.createElement("style");
    style.id = "registration-success-animations";
    style.textContent = `
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes slideUp {
        from {
          opacity: 0;
          transform: translateY(20px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
    `;
    document.head.appendChild(style);
  }
}






// =============================================
// 📍 Google Places Autocomplete — provincia abbreviata (RM, MI, FC...)
// =============================================
document.addEventListener("DOMContentLoaded", function () {
  const addressInput = document.getElementById("CompanyAddress");
  if (!addressInput) return;

  const capInput = document.getElementById("PostalCode");
  const cityInput = document.getElementById("City");
  const provinceInput = document.getElementById("Province");
  const countryInput = document.getElementById("Country");
  const countryCodeInp = document.getElementById("CountryCode");

  // 🧩 Dizionario province → sigla (completo)
  const provinceMap = {
    "Agrigento": "AG", "Alessandria": "AL", "Ancona": "AN", "Aosta": "AO", "Arezzo": "AR",
    "Ascoli Piceno": "AP", "Asti": "AT", "Avellino": "AV", "Bari": "BA", "Barletta-Andria-Trani": "BT",
    "Belluno": "BL", "Benevento": "BN", "Bergamo": "BG", "Biella": "BI", "Bologna": "BO",
    "Bolzano": "BZ", "Brescia": "BS", "Brindisi": "BR", "Cagliari": "CA", "Caltanissetta": "CL",
    "Campobasso": "CB", "Carbonia-Iglesias": "CI", "Caserta": "CE", "Catania": "CT", "Catanzaro": "CZ",
    "Chieti": "CH", "Como": "CO", "Cosenza": "CS", "Cremona": "CR", "Crotone": "KR",
    "Cuneo": "CN", "Enna": "EN", "Fermo": "FM", "Ferrara": "FE", "Firenze": "FI",
    "Foggia": "FG", "Forlì-Cesena": "FC", "Frosinone": "FR", "Genova": "GE", "Gorizia": "GO",
    "Grosseto": "GR", "Imperia": "IM", "Isernia": "IS", "La Spezia": "SP", "L'Aquila": "AQ",
    "Latina": "LT", "Lecce": "LE", "Lecco": "LC", "Livorno": "LI", "Lodi": "LO",
    "Lucca": "LU", "Macerata": "MC", "Mantova": "MN", "Massa-Carrara": "MS", "Matera": "MT",
    "Medio Campidano": "VS", "Messina": "ME", "Milano": "MI", "Modena": "MO", "Monza e della Brianza": "MB",
    "Napoli": "NA", "Novara": "NO", "Nuoro": "NU", "Olbia-Tempio": "OT", "Oristano": "OR",
    "Padova": "PD", "Palermo": "PA", "Parma": "PR", "Pavia": "PV", "Perugia": "PG",
    "Pesaro e Urbino": "PU", "Pescara": "PE", "Piacenza": "PC", "Pisa": "PI", "Pistoia": "PT",
    "Pordenone": "PN", "Potenza": "PZ", "Prato": "PO", "Ragusa": "RG", "Ravenna": "RA",
    "Reggio Calabria": "RC", "Reggio Emilia": "RE", "Rieti": "RI", "Rimini": "RN", "Roma": "RM",
    "Rovigo": "RO", "Salerno": "SA", "Sassari": "SS", "Savona": "SV", "Siena": "SI",
    "Siracusa": "SR", "Sondrio": "SO", "Taranto": "TA", "Teramo": "TE", "Terni": "TR",
    "Torino": "TO", "Trapani": "TP", "Trento": "TN", "Treviso": "TV", "Trieste": "TS",
    "Udine": "UD", "Varese": "VA", "Venezia": "VE", "Verbania": "VB", "Vercelli": "VC",
    "Verona": "VR", "Vibo Valentia": "VV", "Vicenza": "VI", "Viterbo": "VT"
  };

  // 🧩 Lista completa delle province per il menu a tendina
  const provinceList = [
    { name: "Agrigento", code: "AG" }, { name: "Alessandria", code: "AL" }, { name: "Ancona", code: "AN" },
    { name: "Aosta", code: "AO" }, { name: "Arezzo", code: "AR" }, { name: "Ascoli Piceno", code: "AP" },
    { name: "Asti", code: "AT" }, { name: "Avellino", code: "AV" }, { name: "Bari", code: "BA" },
    { name: "Barletta-Andria-Trani", code: "BT" }, { name: "Belluno", code: "BL" }, { name: "Benevento", code: "BN" },
    { name: "Bergamo", code: "BG" }, { name: "Biella", code: "BI" }, { name: "Bologna", code: "BO" },
    { name: "Bolzano", code: "BZ" }, { name: "Brescia", code: "BS" }, { name: "Brindisi", code: "BR" },
    { name: "Cagliari", code: "CA" }, { name: "Caltanissetta", code: "CL" }, { name: "Campobasso", code: "CB" },
    { name: "Carbonia-Iglesias", code: "CI" }, { name: "Caserta", code: "CE" }, { name: "Catania", code: "CT" },
    { name: "Catanzaro", code: "CZ" }, { name: "Chieti", code: "CH" }, { name: "Como", code: "CO" },
    { name: "Cosenza", code: "CS" }, { name: "Cremona", code: "CR" }, { name: "Crotone", code: "KR" },
    { name: "Cuneo", code: "CN" }, { name: "Enna", code: "EN" }, { name: "Fermo", code: "FM" },
    { name: "Ferrara", code: "FE" }, { name: "Firenze", code: "FI" }, { name: "Foggia", code: "FG" },
    { name: "Forlì-Cesena", code: "FC" }, { name: "Frosinone", code: "FR" }, { name: "Genova", code: "GE" },
    { name: "Gorizia", code: "GO" }, { name: "Grosseto", code: "GR" }, { name: "Imperia", code: "IM" },
    { name: "Isernia", code: "IS" }, { name: "La Spezia", code: "SP" }, { name: "L'Aquila", code: "AQ" },
    { name: "Latina", code: "LT" }, { name: "Lecce", code: "LE" }, { name: "Lecco", code: "LC" },
    { name: "Livorno", code: "LI" }, { name: "Lodi", code: "LO" }, { name: "Lucca", code: "LU" },
    { name: "Macerata", code: "MC" }, { name: "Mantova", code: "MN" }, { name: "Massa-Carrara", code: "MS" },
    { name: "Matera", code: "MT" }, { name: "Medio Campidano", code: "VS" }, { name: "Messina", code: "ME" },
    { name: "Milano", code: "MI" }, { name: "Modena", code: "MO" }, { name: "Monza e della Brianza", code: "MB" },
    { name: "Napoli", code: "NA" }, { name: "Novara", code: "NO" }, { name: "Nuoro", code: "NU" },
    { name: "Olbia-Tempio", code: "OT" }, { name: "Oristano", code: "OR" }, { name: "Padova", code: "PD" },
    { name: "Palermo", code: "PA" }, { name: "Parma", code: "PR" }, { name: "Pavia", code: "PV" },
    { name: "Perugia", code: "PG" }, { name: "Pesaro e Urbino", code: "PU" }, { name: "Pescara", code: "PE" },
    { name: "Piacenza", code: "PC" }, { name: "Pisa", code: "PI" }, { name: "Pistoia", code: "PT" },
    { name: "Pordenone", code: "PN" }, { name: "Potenza", code: "PZ" }, { name: "Prato", code: "PO" },
    { name: "Ragusa", code: "RG" }, { name: "Ravenna", code: "RA" }, { name: "Reggio Calabria", code: "RC" },
    { name: "Reggio Emilia", code: "RE" }, { name: "Rieti", code: "RI" }, { name: "Rimini", code: "RN" },
    { name: "Roma", code: "RM" }, { name: "Rovigo", code: "RO" }, { name: "Salerno", code: "SA" },
    { name: "Sassari", code: "SS" }, { name: "Savona", code: "SV" }, { name: "Siena", code: "SI" },
    { name: "Siracusa", code: "SR" }, { name: "Sondrio", code: "SO" }, { name: "Taranto", code: "TA" },
    { name: "Teramo", code: "TE" }, { name: "Terni", code: "TR" }, { name: "Torino", code: "TO" },
    { name: "Trapani", code: "TP" }, { name: "Trento", code: "TN" }, { name: "Treviso", code: "TV" },
    { name: "Trieste", code: "TS" }, { name: "Udine", code: "UD" }, { name: "Varese", code: "VA" },
    { name: "Venezia", code: "VE" }, { name: "Verbania", code: "VB" }, { name: "Vercelli", code: "VC" },
    { name: "Verona", code: "VR" }, { name: "Vibo Valentia", code: "VV" }, { name: "Vicenza", code: "VI" },
    { name: "Viterbo", code: "VT" }
  ];

  // 🔄 Funzione per sostituire l'input della provincia con un menu a tendina
  function replaceProvinceInputWithDropdown() {
    const provinceField = document.getElementById('Province');

    // Se è già un menu a tendina, non fare nulla
    if (provinceField && provinceField.tagName === 'SELECT') {
      return provinceField;
    }

    // Se è un input, sostituiscilo con un menu a tendina
    if (provinceField && provinceField.tagName === 'INPUT') {
      // Crea il menu a tendina
      const dropdown = document.createElement('select');
      dropdown.id = 'Province'; // Mantiene lo stesso ID dell'input originale
      dropdown.className = provinceField.className; // Mantiene le stesse classi CSS
      // Non impostiamo stili inline per mantenere la coerenza con gli altri campi
      // Gli stili verranno applicati tramite le classi CSS esistenti

      // Aggiungi l'opzione predefinita
      const defaultOption = document.createElement('option');
      defaultOption.value = '';
      defaultOption.textContent = 'Seleziona una provincia';
      dropdown.appendChild(defaultOption);

      // Aggiungi tutte le province
      provinceList.forEach(province => {
        const option = document.createElement('option');
        option.value = province.code;
        option.textContent = `${province.name} - ${province.code}`;
        dropdown.appendChild(option);
      });

      // Sostituisci l'input con il menu a tendina
      provinceField.parentNode.replaceChild(dropdown, provinceField);

      // Aggiorna il riferimento provinceInput per puntare al nuovo menu a tendina
      window.provinceDropdownRef = dropdown;

      return dropdown;
    }

    return null;
  }

  // 🔄 Funzione per sostituire il menu a tendina della provincia con un campo di input testo
  function replaceProvinceDropdownWithInput() {
    const provinceField = document.getElementById('Province');

    // Se è già un input, non fare nulla
    if (provinceField && provinceField.tagName === 'INPUT') {
      return provinceField;
    }

    // Se è un menu a tendina, sostituiscilo con un input
    if (provinceField && provinceField.tagName === 'SELECT') {
      // Crea un campo di input
      const input = document.createElement('input');
      input.id = 'Province'; // Mantiene lo stesso ID
      input.className = provinceField.className; // Mantiene le stesse classi CSS
      input.type = 'text';
      input.placeholder = 'Inserisci provincia';
      input.name = 'customer[province]';

      // Sostituisci il menu a tendina con l'input
      provinceField.parentNode.replaceChild(input, provinceField);

      // Aggiorna il riferimento
      window.provinceInputRef = input;

      return input;
    }

    return null;
  }

  function normalizeProvince(provinciaRaw) {
    if (!provinciaRaw) return "";

    // 🔧 Rimuove prefissi come "Provincia di", "Città metropolitana di", ecc.
    let cleaned = provinciaRaw
      .replace(/^Provincia di\s*/i, "")
      .replace(/^Città Metropolitana di\s*/i, "")
      .replace(/^Metropolitan City of\s*/i, "")
      .replace(/^Province of\s*/i, "")
      .trim();

    // 🔠 Cerca nel dizionario
    if (provinceMap[cleaned]) return provinceMap[cleaned];

    // 🔍 Cerca corrispondenza parziale nel dizionario (per casi come "Napoli" invece di "Città Metropolitana di Napoli")
    for (const [fullName, abbreviation] of Object.entries(provinceMap)) {
      if (fullName.toLowerCase().includes(cleaned.toLowerCase()) ||
        cleaned.toLowerCase().includes(fullName.toLowerCase())) {
        return abbreviation;
      }
    }

    // fallback: prime due lettere maiuscole
    return cleaned.substring(0, 2).toUpperCase();
  }

  function initAutocomplete() {
    try {
      const autocomplete = new google.maps.places.Autocomplete(addressInput, {
        fields: ["address_components", "geometry"],
        types: ["geocode"],
      });

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        if (!place.address_components) return;

        let route = "", streetNumber = "", postalCode = "",
          city = "", country = "", countryCode = "";

        place.address_components.forEach((c) => {
          const t = c.types;
          if (t.includes("route")) route = c.long_name;
          if (t.includes("street_number")) streetNumber = c.long_name;
          if (t.includes("postal_code")) postalCode = c.long_name;
          if (t.includes("locality")) city = c.long_name;
          if (!city && t.includes("administrative_area_level_3")) city = c.long_name;
          // NOTA: La gestione della provincia è ora gestita nel file main-register.liquid
          if (t.includes("country")) {
            countryCode = c.short_name?.toUpperCase() || "";

            try {
              // ✅ Usa il nome ufficiale inglese del paese per Shopify
              const regionNamesInEnglish = new Intl.DisplayNames(["en"], { type: "region" });
              country = regionNamesInEnglish.of(countryCode);
            } catch (err) {
              // ⚠️ Fallback per browser vecchi
              country = c.long_name || "";
            }
          }

        });

        addressInput.value = [route, streetNumber].filter(Boolean).join(", ");
        if (capInput) capInput.value = postalCode || "";
        if (cityInput) cityInput.value = city || "";
        // NOTA: L'assegnazione automatica della provincia è gestita in main-register.liquid
        if (countryInput) countryInput.value = country || "";
        if (countryCodeInp) countryCodeInp.value = (countryCode || "").toUpperCase();
      });

      debugLog("✅ Google Autocomplete per indirizzo attivo (provincia gestita separatamente)");
    } catch (err) {
      debugWarn("⚠️ Autocomplete non disponibile:", err);
    }
  }

  function waitForGoogle() {
    if (typeof google !== "undefined" && google.maps && google.maps.places) {
      initAutocomplete();
    } else {
      setTimeout(waitForGoogle, 400);
    }
  }
  waitForGoogle();

  // NOTA: Il campo Provincia è gestito dal sistema di autocomplete in main-register.liquid
  // Le funzioni replaceProvinceInputWithDropdown e replaceProvinceDropdownWithInput
  // sono mantenute per compatibilità ma non vengono utilizzate attivamente
});






// ======================================================
// 💚 MESSAGGIO VERDE DI SUCCESSO EMAIL DI ATTIVAZIONE
// ======================================================
document.addEventListener("DOMContentLoaded", () => {
  const errorContainers = document.querySelectorAll(
    ".errors, .form__message, .product-form__error-message-wrapper"
  );

  errorContainers.forEach((errorBox) => {
    if (!errorBox) return;

    const msg = errorBox.innerText.trim();

    if (
      msg.includes("Abbiamo inviato un'e") ||
      msg.includes("Ti abbiamo inviato un'") ||
      msg.includes("We've sent an email") ||
      msg.includes("We've sent an email")
    ) {
      document.body.classList.add("email-sent-success");

      // Rimuovi elementi di errore
      document.querySelectorAll(
        ".product-form__error-message-wrapper, .icon-error, .icon--alert, svg[fill='none']"
      ).forEach((el) => el.remove());

      // Crea un banner di successo centrato
      const successBanner = document.createElement("div");
      successBanner.className = "success-message";
      successBanner.style.cssText = `
        text-align: center;
        padding: 1.5rem;
        background: #f0fdf4;
        border: 1px solid #bbf7d0;
        border-radius: 8px;
        margin: 1rem 0;
        display: flex;
        flex-direction: column;
        align-items: center;
      `;

      successBanner.innerHTML = `
        <div style="display: flex; align-items: center; justify-content: center; margin-bottom: 0.5rem;">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#22c55e" viewBox="0 0 24 24" style="margin-right: 0.5rem;">
            <path d="M9 16.17L4.83 12 3.41 13.41 9 19 21 7l-1.41-1.41L9 16.17z"/>
          </svg>
          <strong style="color: #16a34a; font-size: 1.1rem;">Registrazione completata!</strong>
        </div>
        <p style="color: #15803d; margin: 0; line-height: 1.5;">${msg}</p>
      `;

      errorBox.innerHTML = "";
      errorBox.appendChild(successBanner);

      // Nascondi il form di registrazione dopo la registrazione completata con successo
      const formSections = document.querySelectorAll('.custom-form-section--type, .custom-form-section--personal, .custom-form-section--submit');
      formSections.forEach(section => {
        section.style.display = 'none';
      });

      // Rimuovi eventuali titoli di errore
      const headings = document.querySelectorAll("strong, .form__message strong");
      headings.forEach(heading => {
        if (heading && (heading.textContent.includes("Correggi gli errori") || heading.textContent.includes("Email è già stato scelto"))) {
          if (heading.parentElement) {
            heading.parentElement.remove();
          }
        }
      });
    }

    // Gestione specifica per il messaggio "Email è già stato scelto" quando in realtà è un successo
    if (msg.includes("Email è già stato scelto") && document.body.classList.contains("email-sent-success")) {
      // Nascondi questo messaggio specifico se è già stato identificato come successo
      errorBox.style.display = 'none';
    }
  });
});

// ======================================================
// 🎭 GESTIONE TRANSIZIONI FLUIDE TRA CATEGORIE AZIENDA
// ======================================================
document.addEventListener('DOMContentLoaded', function () {
  // Funzioni utility per bloccare/sbloccare campi con animazione
  function lockCompanyFields() {
    const fields = [
      'CompanyName', 'CompanyAddress', 'CompanyCity',
      'CompanyProvince', 'CompanyZip', 'CompanyCountry', 'CompanyPhone'
    ];

    fields.forEach(fieldId => {
      const field = document.getElementById(fieldId);
      if (field) {
        // Aggiungi classe per animazione
        field.classList.add('field-locking');
        setTimeout(() => {
          field.disabled = true;
          field.style.backgroundColor = '#f5f5f5';
          field.style.cursor = 'not-allowed';
          field.classList.remove('field-locking');
          field.classList.add('field-locked');
        }, 150);
      }
    });

    // NOTA: Il campo Provincia è gestito dal sistema di autocomplete in main-register.liquid
    // Il codice per bloccare il campo provincia è mantenuto per riferimento ma non utilizzato
  }

  function unlockCompanyFields() {
    const fields = [
      'CompanyName', 'CompanyAddress', 'CompanyCity',
      'CompanyProvince', 'CompanyZip', 'CompanyCountry', 'CompanyPhone'
    ];

    fields.forEach(fieldId => {
      const field = document.getElementById(fieldId);
      if (field) {
        // Aggiungi classe per animazione
        field.classList.add('field-unlocking');
        setTimeout(() => {
          field.disabled = false;
          field.style.backgroundColor = '';
          field.style.cursor = '';
          field.classList.remove('field-unlocking');
          field.classList.remove('field-locked');
        }, 150);
      }
    });

    // NOTA: Il campo Provincia è gestito dal sistema di autocomplete in main-register.liquid
    // Il codice per sbloccare il campo provincia è mantenuto per riferimento ma non utilizzato
  }

  // Funzione per transizione fluida tra categorie
  function transitionToCategory(categoryType) {
    const categoriaButtons = document.querySelectorAll('.categoria-btn');
    const aziendaFields = document.getElementById('azienda-fields');

    // Disabilita temporaneamente tutti i pulsanti per evitare clic multipli
    categoriaButtons.forEach(btn => {
      btn.disabled = true;
      btn.style.pointerEvents = 'none';
    });

    // Rimuovi classe active da tutti i pulsanti con animazione
    categoriaButtons.forEach(btn => {
      btn.classList.remove('active');
      btn.style.transform = 'scale(1)';
    });

    // Aggiungi classe active al pulsante selezionato con animazione
    setTimeout(() => {
      const activeBtn = document.querySelector(`[data-category="${categoryType}"]`);
      if (activeBtn) {
        activeBtn.classList.add('active');
        activeBtn.style.transform = 'scale(1.05)';
      }
    }, 100);

    // Gestisci la transizione dei campi in base alla categoria
    switch (categoryType) {
      case 'professionista':
        handleProfessionistaTransition();
        break;
      case 'azienda-estera':
        handleAziendaEsteraTransition();
        break;
      case 'azienda-italia':
        handleAziendaItaliaTransition();
        break;
    }

    // Riabilita i pulsanti dopo la transizione
    setTimeout(() => {
      categoriaButtons.forEach(btn => {
        btn.disabled = false;
        btn.style.pointerEvents = 'auto';
      });
    }, 600);
  }

  function handleProfessionistaTransition() {
    const aziendaFields = document.getElementById('azienda-fields');
    const fiscalCodeField = document.getElementById('FiscalCode');
    const sdiField = document.getElementById('SdiCode');

    // Mostra form azienda con animazione
    if (aziendaFields) {
      aziendaFields.style.display = 'block';
      aziendaFields.classList.add('form-slide-in');

      // Blocca campi inizialmente
      lockCompanyFields();

      // Mostra campi CF e SDI con animazione
      if (fiscalCodeField) {
        fiscalCodeField.parentElement.style.display = 'block';
        fiscalCodeField.parentElement.classList.add('form-fade-in');
      }
      if (sdiField) {
        sdiField.parentElement.style.display = 'block';
        sdiField.parentElement.classList.add('form-fade-in');
      }

      // NOTA: Il campo Provincia è gestito dal sistema di autocomplete in main-register.liquid
      // La funzione replaceProvinceInputWithDropdown() è disponibile ma non utilizzata
    }
  }

  function handleAziendaEsteraTransition() {
    const aziendaFields = document.getElementById('azienda-fields');
    const fiscalCodeField = document.getElementById('FiscalCode');
    const sdiField = document.getElementById('SdiCode');

    // NOTA: Il campo Provincia è gestito dal sistema di autocomplete in main-register.liquid
    // La funzione replaceProvinceDropdownWithInput() è disponibile ma non utilizzata

    // Mostra form azienda con animazione
    if (aziendaFields) {
      aziendaFields.style.display = 'block';
      aziendaFields.classList.add('form-slide-in');

      // Blocca campi inizialmente
      lockCompanyFields();

      // Nascondi campi CF e SDI con animazione
      if (fiscalCodeField) {
        fiscalCodeField.parentElement.classList.add('form-fade-out');
        setTimeout(() => {
          fiscalCodeField.parentElement.style.display = 'none';
          fiscalCodeField.parentElement.classList.remove('form-fade-out');
        }, 300);
      }
      if (sdiField) {
        sdiField.parentElement.classList.add('form-fade-out');
        setTimeout(() => {
          sdiField.parentElement.style.display = 'none';
          sdiField.parentElement.classList.remove('form-fade-out');
        }, 300);
      }
    }
  }

  function handleAziendaItaliaTransition() {
    const aziendaFields = document.getElementById('azienda-fields');
    const fiscalCodeField = document.getElementById('FiscalCode');
    const sdiField = document.getElementById('SdiCode');

    // Mostra form azienda con animazione
    if (aziendaFields) {
      aziendaFields.style.display = 'block';
      aziendaFields.classList.add('form-slide-in');

      // Blocca campi inizialmente
      lockCompanyFields();

      // Mostra campi CF e SDI con animazione
      if (fiscalCodeField) {
        fiscalCodeField.parentElement.style.display = 'block';
        fiscalCodeField.parentElement.classList.add('form-fade-in');
      }
      if (sdiField) {
        sdiField.parentElement.style.display = 'block';
        sdiField.parentElement.classList.add('form-fade-in');
      }

      // NOTA: Il campo Provincia è gestito dal sistema di autocomplete in main-register.liquid
      // La funzione replaceProvinceInputWithDropdown() è disponibile ma non utilizzata
    }
  }

  // Aggiungi event listener per i pulsanti categoria
  const categoriaButtons = document.querySelectorAll('.categoria-btn');
  categoriaButtons.forEach(button => {
    button.addEventListener('click', function () {
      const category = this.getAttribute('data-category');
      transitionToCategory(category);
    });

    // Aggiungi effetti hover
    button.addEventListener('mouseenter', function () {
      if (!this.classList.contains('active')) {
        this.style.transform = 'scale(1.02)';
      }
    });

    button.addEventListener('mouseleave', function () {
      if (!this.classList.contains('active')) {
        this.style.transform = 'scale(1)';
      }
    });
  });

  // Aggiungi listener per il campo P.IVA per sbloccare campi
  const vatNumberField = document.getElementById('VatNumber');
  if (vatNumberField) {
    vatNumberField.addEventListener('input', function () {
      const value = this.value.trim();
      const activeCategory = document.querySelector('.categoria-btn.active');

      if (activeCategory) {
        const categoryType = activeCategory.getAttribute('data-category');

        // Logica di sblocco basata sulla categoria
        if (categoryType === 'professionista' && value.length >= 8) {
          unlockCompanyFields();
        } else if (categoryType === 'azienda-estera' && value.length >= 8) {
          unlockCompanyFields();
        } else if (categoryType === 'azienda-italia' && value.length >= 8) {
          // Per azienda italiana, potrebbe essere necessaria una chiamata API
          // Per ora sbloccamo dopo 8 caratteri
          unlockCompanyFields();
        }
      }
    });
  }

  debugLog("✅ Sistema transizioni fluide categorie inizializzato");
});

// ======================================================
// 🎨 AGGIUNTA STILI CSS PER ANIMAZIONI FLUIDE
// ======================================================
(function () {
  const styles = `
    /* Animazioni per transizioni fluide tra form */
    .form-slide-in {
      animation: slideInFromRight 0.4s ease-out forwards;
    }
    
    .form-slide-out {
      animation: slideOutToRight 0.3s ease-in forwards;
    }
    
    .form-fade-in {
      animation: fadeIn 0.3s ease-out forwards;
    }
    
    .form-fade-out {
      animation: fadeOut 0.3s ease-in forwards;
    }
    
    .form-slide-in-left {
      animation: slideInFromLeft 0.4s ease-out forwards;
    }
    
    .form-slide-out-left {
      animation: slideOutToLeft 0.3s ease-in forwards;
    }
    
    .form-slide-in-right {
      animation: slideInFromRight 0.4s ease-out forwards;
    }
    
    .form-slide-out-right {
      animation: slideOutToRight 0.3s ease-in forwards;
    }
    
    /* Animazioni per campi bloccati/sbloccati */
    .field-locking {
      animation: fieldLock 0.2s ease-in forwards;
    }
    
    .field-unlocking {
      animation: fieldUnlock 0.2s ease-out forwards;
    }
    
    .field-locked {
      transition: all 0.3s ease;
      opacity: 0.7;
    }
    
    /* Animazioni per pulsanti categoria */
    .categoria-btn {
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;
      overflow: hidden;
    }
    
    .categoria-btn::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 0;
      height: 0;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.3);
      transform: translate(-50%, -50%);
      transition: width 0.6s, height 0.6s;
    }
    
    .categoria-btn:hover::before {
      width: 300px;
      height: 300px;
    }
    
    .categoria-btn.active {
      transform: scale(1.05);
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
    }
    
    /* Animazioni per sezione categorie */
    #categoria-section {
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      transform-origin: top center;
    }
    
    #categoria-section.form-slide-in-right {
      animation: slideInFromRight 0.5s cubic-bezier(0.4, 0, 0.2, 1) forwards;
    }
    
    #categoria-section.form-slide-out-right {
      animation: slideOutToRight 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards;
    }
    
    /* Definizioni keyframe */
    @keyframes slideInFromRight {
      from {
        opacity: 0;
        transform: translateX(30px);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }
    
    @keyframes slideOutToRight {
      from {
        opacity: 1;
        transform: translateX(0);
      }
      to {
        opacity: 0;
        transform: translateX(30px);
      }
    }
    
    @keyframes slideInFromLeft {
      from {
        opacity: 0;
        transform: translateX(-30px);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }
    
    @keyframes slideOutToLeft {
      from {
        opacity: 1;
        transform: translateX(0);
      }
      to {
        opacity: 0;
        transform: translateX(-30px);
      }
    }
    
    @keyframes fadeIn {
      from {
        opacity: 0;
        transform: translateY(10px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    
    @keyframes fadeOut {
      from {
        opacity: 1;
        transform: translateY(0);
      }
      to {
        opacity: 0;
        transform: translateY(-10px);
      }
    }
    
    @keyframes fieldLock {
      from {
        opacity: 1;
        transform: scale(1);
      }
      to {
        opacity: 0.7;
        transform: scale(0.98);
      }
    }
    
    @keyframes fieldUnlock {
      from {
        opacity: 0.7;
        transform: scale(0.98);
      }
      to {
        opacity: 1;
        transform: scale(1);
      }
    }
    
    /* Stili per transizioni fluide tra categorie */
    .category-transition {
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }
    
    /* Effetto di ripple per pulsanti */
    .ripple-effect {
      position: relative;
      overflow: hidden;
    }
    
    .ripple-effect::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 5px;
      height: 5px;
      background: rgba(255, 255, 255, 0.5);
      opacity: 0;
      border-radius: 100%;
      transform: scale(1, 1) translate(-50%);
      transform-origin: 50% 50%;
    }
    
    .ripple-effect:focus:not(:active)::after {
      animation: ripple 1s ease-out;
    }
    
    @keyframes ripple {
      0% {
        transform: scale(0, 0);
        opacity: 1;
      }
      20% {
        transform: scale(25, 25);
        opacity: 1;
      }
      100% {
        opacity: 0;
        transform: scale(40, 40);
      }
    }
    
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;

  // Crea e inserisci gli stili nel DOM
  const styleSheet = document.createElement('style');
  styleSheet.textContent = styles;
  styleSheet.id = 'registration-animations';
  document.head.appendChild(styleSheet);

  debugLog("✅ Stili animazioni transizioni fluide caricati");
})();


// ======================================================
// 📨 REGISTRAZIONE CLIENTE SOLO TRAMITE BACKEND
// ======================================================
document.addEventListener("DOMContentLoaded", () => {
  const form = document.querySelector("#register-form");
  if (!form) {
    console.error("❌ Form di registrazione non trovato");
    return;
  }

  // Disabilita completamente l'invio nativo del form (doppia sicurezza)
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    return false;
  }, true); // Usa capture phase per intercettare prima

  // Aggiorna il riferimento al pulsante
  elements.submitBtn = document.getElementById("register-submit-btn") ||
    document.querySelector("#register-form button[type='submit'], #register-form input[type='submit']");

  // Gestisci il click sul pulsante invece del submit del form
  if (!elements.submitBtn) {
    console.error("❌ Errore: pulsante di submit non trovato");
    return;
  }

  // Flag per prevenire doppie chiamate
  let isSubmitting = false;

  elements.submitBtn.addEventListener("click", async function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    // Prevenzione doppia chiamata
    if (isSubmitting) {
      debugWarn("⚠️ Registrazione già in corso, ignoro click duplicato");
      return false;
    }

    if (!elements.submitBtn) {
      console.error("❌ Errore: pulsante di submit non trovato");
      return false;
    }

    // Categoria selezionata
    const activeCategoryBtn =
      document.querySelector(".category-btn.is-active") ||
      document.querySelector(".category-btn.active");
    const aziendaCategory = activeCategoryBtn
      ? activeCategoryBtn.getAttribute("data-category")
      : "";

    // Prima valida i campi obbligatori
    if (!validateRequiredFields(aziendaCategory)) {
      elements.submitBtn.disabled = false;
      isSubmitting = false;
      return;
    }

    // Imposta flag solo dopo validazione OK
    isSubmitting = true;

    // Disabilita UI solo dopo validazione OK
    const originalText = elements.submitBtn.textContent;
    elements.submitBtn.textContent = "Creazione account...";
    elements.submitBtn.disabled = true;

    // Crea payload completo con tutti i dati necessari
    const payload = createRegistrationPayload(aziendaCategory);

    // Assicuriamoci che tutti i campi siano inclusi correttamente
    // Aggiungiamo esplicitamente i campi che potrebbero mancare
    if (aziendaCategory) {
      // Per aziende, assicuriamoci che tutti i campi aziendali siano inclusi
      payload.extra_fields.azienda = document.getElementById("CompanyName")?.value.trim() || "";
      payload.extra_fields.indirizzo_azienda = document.getElementById("CompanyAddress")?.value.trim() || "";
      payload.extra_fields.partita_iva = sanitizeDigits(document.getElementById("VatNumber")?.value.trim() || "", 11);

      // Campi indirizzo per il backend - assicuriamoci che abbiano i nomi corretti
      // Per le aziende, usa sempre i campi di fatturazione
      const capValue = document.getElementById("CAPFattura")?.value.trim() || "";
      const cittaValue = document.getElementById("CittaFattura")?.value.trim() || "";

      // Per la provincia: se è azienda estera, non normalizzare (usa il valore raw)
      // Se è azienda italiana, normalizza la provincia
      const isAziendaEstera = aziendaCategory === "azienda-estera";
      const provinciaRaw = document.getElementById("ProvinciaFattura")?.value.trim() || "";
      const provinciaValue = isAziendaEstera ? provinciaRaw : normalizeProvince(provinciaRaw);

      // Per l'indirizzo, usa IndirizzoFattura come priorità, altrimenti CompanyAddress
      const indirizzoValue = document.getElementById("IndirizzoFattura")?.value.trim() ||
        document.getElementById("CompanyAddress")?.value.trim() || "";

      // Assegna i valori a extra_fields con i nomi corretti per il backend
      payload.extra_fields.cap = capValue;
      payload.extra_fields.citta = cittaValue;
      payload.extra_fields.provincia = provinciaValue;
      payload.extra_fields.indirizzo = indirizzoValue;

      // Aggiungi anche i campi principali per l'indirizzo (campi obbligatori per Shopify)
      payload.address1 = indirizzoValue;
      payload.city = cittaValue;
      payload.zip = capValue;
      payload.province = provinciaValue;

      // Distingui tra aziende italiane e aziende estere (usa la variabile già dichiarata sopra)
      if (isAziendaEstera) {
        // Per aziende ESTERE: usa il paese rilevato da Google Places
        const paeseFatturaRaw = document.getElementById("PaeseFattura")?.value?.trim() || "";
        const countryCodeFromField = document.getElementById("CountryCodeFattura")?.value?.trim().toUpperCase() ||
          document.getElementById("PaeseFattura")?.getAttribute("data-country-code")?.toUpperCase() || "IT";

        // 🌍 Funzione per convertire country_code a nome paese in inglese (se il paese è vuoto)
        function getCountryNameFromCode(countryCode) {
          if (!countryCode || countryCode === "IT") return "Italy";

          try {
            // ✅ Usa Intl.DisplayNames se disponibile (supporta tutti i paesi)
            if (typeof Intl !== "undefined" && Intl.DisplayNames) {
              const regionNames = new Intl.DisplayNames(["en"], { type: "region" });
              const countryName = regionNames.of(countryCode);
              if (countryName) return countryName;
            }
          } catch (err) {
            debugWarn(`⚠️ Intl.DisplayNames non disponibile per ${countryCode}`);
          }

          // ⚠️ Fallback: mappa completa (solo se Intl.DisplayNames fallisce)
          const countryMap = {
            "US": "United States", "GB": "United Kingdom", "FR": "France", "DE": "Germany",
            "ES": "Spain", "PT": "Portugal", "NL": "Netherlands", "BE": "Belgium",
            "AT": "Austria", "CH": "Switzerland", "PL": "Poland", "CZ": "Czechia",
            "SE": "Sweden", "NO": "Norway", "DK": "Denmark", "FI": "Finland",
            "IE": "Ireland", "GR": "Greece", "RO": "Romania", "HU": "Hungary",
            "BG": "Bulgaria", "HR": "Croatia", "SK": "Slovakia", "SI": "Slovenia",
            "LT": "Lithuania", "LV": "Latvia", "EE": "Estonia", "CY": "Cyprus",
            "MT": "Malta", "LU": "Luxembourg", "CA": "Canada", "AU": "Australia",
            "NZ": "New Zealand", "JP": "Japan", "CN": "China", "KR": "Korea, Republic of",
            "IN": "India", "BR": "Brazil", "MX": "Mexico", "AR": "Argentina",
            "CL": "Chile", "CO": "Colombia", "PE": "Peru", "ZA": "South Africa",
            "EG": "Egypt", "AE": "United Arab Emirates", "SA": "Saudi Arabia",
            "IL": "Israel", "TR": "Turkey", "RU": "Russian Federation", "UA": "Ukraine"
          };
          return countryMap[countryCode] || "";
        }

        // Determina il paese: usa quello dal campo se presente, altrimenti converti dal country_code
        // ⚠️ NON usare "Italy" come fallback se country_code è diverso da "IT"
        let finalCountry = paeseFatturaRaw;
        if (!finalCountry && countryCodeFromField) {
          if (countryCodeFromField === "IT") {
            finalCountry = "Italy";
          } else {
            // Se il paese è vuoto ma c'è un country_code diverso da "IT", convertilo
            finalCountry = getCountryNameFromCode(countryCodeFromField);
            if (!finalCountry) {
              debugWarn(`⚠️ Paese non trovato per country_code: ${countryCodeFromField}`);
              // Se non trovato, usa il country_code come fallback (non "Italy")
              finalCountry = countryCodeFromField;
            }
          }
        } else if (!finalCountry) {
          // Solo se non c'è né paese né country_code, usa "Italy" come default
          finalCountry = "Italy";
        }

        payload.country = finalCountry;
        payload.country_code = countryCodeFromField;
        payload.extra_fields.country = finalCountry;
        payload.extra_fields.country_code = countryCodeFromField;
      } else {
        // Per aziende ITALIANE: forza sempre "Italy"
        payload.country = "Italy";
        payload.country_code = "IT";
        payload.extra_fields.country = "Italy";
        payload.extra_fields.country_code = "IT";
      }
    } else {
      // Per privati, assicuriamoci che tutti i campi personali siano inclusi
      const capValue = document.getElementById("PostalCode")?.value.trim() || "";
      const cittaValue = document.getElementById("City")?.value.trim() || "";
      const provinciaValue = document.getElementById("Province")?.value || "";
      const indirizzoValue = document.getElementById("Address")?.value.trim() || document.getElementById("CompanyAddress")?.value.trim() || "";

      // Assegna i valori a extra_fields con i nomi corretti per il backend
      payload.extra_fields.cap = capValue;
      payload.extra_fields.citta = cittaValue;
      payload.extra_fields.provincia = provinciaValue;
      payload.extra_fields.indirizzo = indirizzoValue;

      // Aggiungi anche i campi principali per l'indirizzo
      payload.address1 = indirizzoValue;
      payload.city = cittaValue;
      payload.zip = capValue;
      payload.province = provinciaValue;

      // Assicuriamoci che il paese e il country_code siano corretti per i privati
      payload.country = document.getElementById("Country")?.value?.trim() || "Italy";
      payload.country_code = document.getElementById("CountryCode")?.value?.trim().toUpperCase() || "IT";
      payload.extra_fields.country = payload.country;
      payload.extra_fields.country_code = payload.country_code;
    }

    // Aggiungi metafields per la fatturazione automatica
    const fatturaToggle = document.getElementById("fattura-automatica-toggle");
    const fatturaAutomaticamenteValue = fatturaToggle?.checked || false;
    const clienteUEValue = document.getElementById("ClienteUEToggle")?.checked || false;

    // 🔍 Log per debug del toggle fatturazione automatica
    debugLog("🔍 Toggle fatturazione automatica:", {
      toggleElement: fatturaToggle,
      checked: fatturaToggle?.checked,
      fatturaAutomaticamenteValue: fatturaAutomaticamenteValue,
      tipo: typeof fatturaAutomaticamenteValue
    });

    const allMetafieldsForSubmit = {
      "fa_fields.fattura_automatica": fatturaAutomaticamenteValue,
      "fa_fields.cliente_ue": clienteUEValue,
      "fa_fields.ragione_sociale": document.getElementById("RagioneSocialeFattura")?.value.trim() || "",
      "fa_fields.partita_iva": sanitizeDigits(document.getElementById("PartitaIVAFattura")?.value.trim() || "", 11),
      "fa_fields.codice_fiscale": document.getElementById("CodiceFiscaleFattura")?.value.trim() || "",
      "fa_fields.codice_sdi": document.getElementById("CodiceSDIFattura")?.value.trim() || ""
    };

    // 🔒 FILTRA i metafields vuoti per evitare errori 422 "can't be blank" da Shopify
    // Shopify rifiuta metafields con stringa vuota, quindi inviamo solo quelli con valore
    payload.metafields = Object.fromEntries(
      Object.entries(allMetafieldsForSubmit).filter(([key, value]) => {
        // Mantieni i boolean (anche se false) e le stringhe non vuote
        return typeof value === 'boolean' || (typeof value === 'string' && value !== '');
      })
    );

    debugLog("📦 Metafields payload (filtrati):", payload.metafields);

    // Aggiungi flag per invio email
    payload.send_invite = true;

    // Log dettagliato per debug delle aziende
    if (aziendaCategory) {
      debugLog("📦 PAYLOAD AZIENDA - Campi indirizzo:", {
        address1: payload.address1,
        city: payload.city,
        zip: payload.zip,
        province: payload.province,
        country: payload.country,
        country_code: payload.country_code,
        indirizzo_extra: payload.extra_fields.indirizzo,
        citta_extra: payload.extra_fields.citta,
        cap_extra: payload.extra_fields.cap,
        provincia_extra: payload.extra_fields.provincia
      });
    }

    // 🔒 SICUREZZA: Non loggare il payload completo perché contiene la password
    const { password: pwd2, ...payloadWithoutPwd } = payload;
    debugLog("📦 PAYLOAD COMPLETO PER IL BACKEND (senza password):", payloadWithoutPwd);

    try {
      // Mostra barra di caricamento all'inizio del try
      showLoadingBar();

      // ======================================================
      // 1️⃣ CREA CLIENTE SOLO TRAMITE BACKEND API
      // ======================================================
      let createRes;
      try {
        createRes = await fetch("https://api.licenseglobal.it/api/create-customer", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
          signal: AbortSignal.timeout(15000)
        });
      } catch (fetchError) {
        // Gestione specifica per errori di rete
        if (fetchError.name === 'AbortError') {
          throw new Error("Il server impiega troppo tempo. Riprova.");
        } else if (fetchError.message.includes('Failed to fetch')) {
          throw new Error("Impossibile connettersi al server. L'endpoint /api/create-customer potrebbe non essere disponibile. Controlla la configurazione del backend.");
        } else {
          throw fetchError;
        }
      }

      if (!createRes.ok) {
        const errorText = await createRes.text();
        let errorData;
        try {
          errorData = JSON.parse(errorText);
        } catch {
          errorData = { error: errorText || `Errore HTTP: ${createRes.status}` };
        }
        throw new Error(errorData.error || `Errore HTTP: ${createRes.status}`);
      }

      const createData = await createRes.json();
      debugLog("✅ Risposta create-customer:", createData);

      if (createData.status === "exists") {
        isSubmitting = false;
        showEmailExistsWarning(payload.email);
        elements.submitBtn.textContent = originalText;
        elements.submitBtn.disabled = false;
        hideLoadingBar(false);
        return;
      }

      // ======================================================
      // 2️⃣ AGGIORNAMENTO DATI CLIENTE TRAMITE BACKEND (OPZIONALE)
      // ======================================================
      // Nota: Se l'aggiornamento fallisce, il cliente è già stato creato con successo
      // Non mostriamo messaggi di successo - lasciamo che Shopify gestisca il redirect/messaggio standard
      debugLog("🚀 Invio aggiornamento cliente a /api/update-customer...");
      try {
        const updateRes = await fetch("https://api.licenseglobal.it/api/update-customer", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            email: payload.email,
            first_name: payload.first_name,
            last_name: payload.last_name,
            phone: payload.phone, // Aggiunto telefono all'aggiornamento
            // ✅ AGGIUNTO: Invia i campi indirizzo per aggiornare l'indirizzo su Shopify
            address1: payload.address1,
            city: payload.city,
            zip: payload.zip,
            province: payload.province,
            country: payload.country,
            country_code: payload.country_code,
            extra_fields: payload.extra_fields,
            metafields: payload.metafields,
            customer_id: createData.customer_id,
          }),
          signal: AbortSignal.timeout(10000)
        });

        if (updateRes.ok) {
          const updateData = await updateRes.json();
          debugLog("✅ Risposta update-customer:", updateData);
        } else {
          debugWarn("⚠️ Errore HTTP update-customer:", updateRes.status);
          // Non bloccare - il cliente è già stato creato
        }
      } catch (updateError) {
        debugWarn("⚠️ Errore aggiornamento cliente (non bloccante):", updateError);
        // Non bloccare - il cliente è già stato creato con successo
        // I dati verranno sincronizzati automaticamente tramite webhook
      }

      // Nascondi barra di caricamento
      hideLoadingBar(true);

      // Mostra popup di successo invece di redirect
      showRegistrationSuccessModal();

    } catch (err) {
      // Reimposta il flag anche in caso di errore
      isSubmitting = false;

      console.error("❌ Errore registrazione:", err);
      let errorMessage = "Errore durante la registrazione. Riprova più tardi.";

      if (err.name === "AbortError") {
        errorMessage = "Il server impiega troppo tempo. Riprova.";
      } else if (err.name === "TypeError" && err.message.includes("Failed to fetch")) {
        errorMessage = "⚠️ Impossibile connettersi al server API. L'endpoint /api/create-customer potrebbe non essere ancora disponibile sul backend. Verifica che il file create-customer.js sia stato deployato correttamente sul server.";
      } else if (err.message) {
        errorMessage = err.message;
      }

      // Nascondi barra di caricamento con errore nel catch
      hideLoadingBar(false);

      // Mostra errore
      const errorDiv = document.createElement('div');
      errorDiv.className = 'registration-error';
      errorDiv.style.cssText = `
        padding: 12px 16px;
        margin-top: 10px;
        background: #fef2f2;
        border: 1px solid #fecaca;
        color: #991b1b;
        border-radius: 6px;
        font-size: 0.9rem;
        font-weight: 500;
        text-align: center;
      `;
      errorDiv.textContent = errorMessage;

      if (form) {
        form.appendChild(errorDiv);
        setTimeout(() => errorDiv.remove(), 5000);
      }
    }

    // Reimposta il bottone e il flag
    isSubmitting = false;
    elements.submitBtn.textContent = originalText;
    elements.submitBtn.disabled = false;
  });
});
